// a library to wrap and simplify api calls
import axios from 'axios'
// API_LINK
const serverUrl = `${API_LINK}/fastquotes/v100/`

const tokenElement = document.getElementById('token')
const token = tokenElement.value
tokenElement.parentNode.removeChild(tokenElement)

// our "constructor"
const api = axios.create({
  baseURL: `${serverUrl}`,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  }
})

const setHeader = (name, value) => {
  if (value) {
    axios.defaults.headers.common[name] = value
  } else {
    delete axios.defaults.headers.common[name]
  }
}

const endpoints = {

  // post

  // put

  // get
  domexParams: () => api.get('domex-params'),
  calculateDomexQuote: (params) => api.get(`calculate-domex-quote`, { params }),

  // delete

  // helpers
  serverUrl,
  setHeader
}

export default endpoints
